<div class="d-flex align-items-center" style="gap: 16px">
  <ng-container *ngIf="active < 3">
    <progressbar
      class="mx-3"
      style="border-radius: 8px; height: 8px; width: 13em"
      [value]="progress * 100"
      [type]="active == 1 ? 'success' : 'danger'"
    >
    </progressbar>

    <p
      class="m-0"
      [ngStyle]="{ color: active == 1 ? 'var(--green-base)' : 'var(--red-base)' }"
      style="font-size: 12px; font-weight: 700"
    >
      {{ dateText }}
    </p>
  </ng-container>

  <ng-container *ngIf="active == 3">
    <p class="m-0" style="color: var(--red-base); font-weight: bold; font-size: 12px">
      <i class="fa-solid fa-triangle-exclamation" style="margin-right: 8px"></i>
      Garantia Expirada
    </p>
  </ng-container>
</div>
